module.exports = __webpack_public_path__ + "img/haut-und-haarpflege_LR_ALOE_VIA1_hintergrund.c74a10e8.jpg";